<template>
	<div v-if="hasFilters">
		<IntNavButton
			type="button"
			color="tint"
			fit-content
			@click="onOpenButtonClick"
			class="md:hidden"
		>
			Filter results
		</IntNavButton>

		<div
			:class="[
				mobileFiltersOpen
					? 'fixed top-0 left-0 z-20 h-full w-full overflow-scroll bg-white p-6 pb-12'
					: 'hidden',
				'md:block',
			]"
		>
			<IntAccordionItem
				v-for="filter in filters"
				:key="'product-filter-' + filter.name"
				:title="filter.label"
				:expanded="filter.accordionOpen"
				:label-id="`filter-${filter.name}-label`"
				:label="`Filter products ${filter.label}`"
			>
				<IntFormItem field="filters">
					<IntControlGroup
						:labelled-by="`filter-${filter.name}-label`"
						:options="filter.options"
						:name="`filters-${filter.name}`"
						:id="`product-filter-${filter.name}`"
						:value="
							filter.name === 'searchFilter'
								? selectedSearchFilter
								: filter.name === 'category'
									? selectedCategory
									: filter.name === 'range'
										? selectedRange
										: filter.name === 'item'
											? selectedItem
											: selectedSize
						"
						@controlCheckedUpdate="onControlUpdatedEvent($event, filter.name)"
						class="mt-2"
						:disabled="filtersDisabled"
					>
					</IntControlGroup>
				</IntFormItem>
			</IntAccordionItem>
		</div>

		<div
			:class="[
				{ hidden: !mobileFiltersOpen },
				'fixed bottom-0 left-0 z-20 w-full bg-white p-6',
			]"
		>
			<IntNavButton type="button" color="tint" fit-content @click="onCloseButtonClick">
				View results
			</IntNavButton>
		</div>
	</div>
</template>

<script>
import Base from "../base.js"
import EventBus from "../../../../bus"
import Events from "../../../search/events"
import EventsNews from "../../../news-listing/events"
import UrlUpdater from "../../../news-listing/utils/url-updater"
import { cloneObject } from "../../../../utils"

import IntAccordionItem from "../../../accordion/modules/accordion-item.vue"
import IntControlGroup from "../../../form/modules/control/group.vue"
import IntFormItem from "../../../form/modules/form-item"
import IntNavButton from "../../../nav-button"

export default {
	name: "IntFilters",

	mixins: [Base],

	components: { IntAccordionItem, IntControlGroup, IntFormItem, IntNavButton },

	props: {
		selectionCriteria: { type: String, required: true },
		initialFilters: { type: Array, default: [] },
	},

	data() {
		return {
			filters: this.initialFilters.filter((filter) => filter.display === true) || [],
			filtersDisabled: false,
			selectedSearchFilter: [],
			selectedCategory: [],
			selectedRange: [],
			selectedItem: [],
			selectedSize: [],
			mobileFiltersOpen: false,
		}
	},

	computed: {
		hasFilters() {
			return (
				this.filters &&
				this.filters.some(
					(filter) =>
						filter.display === true && filter.options && filter.options.length > 0,
				)
			)
		},
	},

	created() {
		EventBus.$on(EventsNews.resultsFetched, this.onResultsFetchedEvent)
		EventBus.$on(Events.statusUpdated, this.onStatusUpdatedEvent)

		UrlUpdater.registerEvent(Events.filtersUpdated, "searchFilters")
		UrlUpdater.registerEvent(Events.filtersUpdated, "categories")
		UrlUpdater.registerEvent(Events.filtersUpdated, "ranges")
		UrlUpdater.registerEvent(Events.filtersUpdated, "items")
		UrlUpdater.registerEvent(Events.filtersUpdated, "sizes")

		this.updateSelectedFilters()
	},

	methods: {
		onResultsFetchedEvent(e) {
			this.filters = e.data.filters.filter(
				(filter) => filter.display === true && filter.options && filter.options.length > 0,
			)

			this.updateSelectedFilters()

			this.filtersDisabled = false
		},

		onControlUpdatedEvent(e, filterName) {
			this.filtersDisabled = true

			if (filterName === "searchFilter") this.selectedSearchFilter = e
			if (filterName === "category") this.selectedCategory = e
			if (filterName === "range") this.selectedRange = e
			if (filterName === "item") this.selectedItem = e
			if (filterName === "size") this.selectedSize = e

			const filtersToDisplay = this.filters.map((filter) => filter.name)

			const event = {
				data: {
					pageNumber: 1,
					selectionCriteria: this.selectionCriteria,
					filtersToDisplay: filtersToDisplay,
					searchFilters: cloneObject(this.selectedSearchFilter),
					categories: cloneObject(this.selectedCategory),
					ranges: cloneObject(this.selectedRange),
					items: cloneObject(this.selectedItem),
					sizes: cloneObject(this.selectedSize),
				},
				group: this.group,
			}

			EventBus.$emit(Events.filtersUpdated, event)
		},

		onStatusUpdatedEvent(e) {
			this.filtersDisabled = e === "loading"
		},

		onOpenButtonClick() {
			return (this.mobileFiltersOpen = !this.mobileFiltersOpen)
		},

		onCloseButtonClick() {
			this.mobileFiltersOpen = false
		},

		updateSelectedFilters() {
			const selectedSearchFilters = []
			const selectedCategories = []
			const selectedRanges = []
			const selectedItems = []
			const selectedSizes = []

			this.filters.forEach((filter) => {
				if (filter.name === "searchFilter") {
					filter.options.forEach((option) => {
						if (option.selected) selectedSearchFilters.push(option.value)
					})
				} else if (filter.name === "category") {
					filter.options.forEach((option) => {
						if (option.selected) selectedCategories.push(option.value)
					})
				} else if (filter.name === "range") {
					filter.options.forEach((option) => {
						if (option.selected) selectedRanges.push(option.value)
					})
				} else if (filter.name === "item") {
					filter.options.forEach((option) => {
						if (option.selected) selectedItems.push(option.value)
					})
				} else if (filter.name === "size") {
					filter.options.forEach((option) => {
						if (option.selected) selectedSizes.push(option.value)
					})
				}
			})

			this.selectedSearchFilter = selectedSearchFilters
			this.selectedCategory = selectedCategories
			this.selectedRange = selectedRanges
			this.selectedItem = selectedItems
			this.selectedSize = selectedSizes
		},
	},
}
</script>
